/**
 * Theme preference.
 *
 * Three states, not two: light, dark, and "follow the system". The default is the system
 * setting — a product meant to reduce anxiety should not override what someone already told
 * their operating system.
 */
export type Theme = 'light' | 'dark' | 'system';

const STORAGE_KEY = 'mailbutler.theme';

export function readTheme(): Theme {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'light' || stored === 'dark' || stored === 'system') return stored;
  } catch {
    // Blocked storage: fall back to the system preference.
  }
  return 'system';
}

export function applyTheme(theme: Theme): void {
  const root = document.documentElement;
  if (theme === 'system') {
    root.removeAttribute('data-theme');
  } else {
    root.setAttribute('data-theme', theme);
  }

  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    // The choice still applies for this session.
  }
}

/** Cycles light → dark → system, which is what a single toggle should do with three states. */
export function nextTheme(current: Theme): Theme {
  if (current === 'system') return 'light';
  return current === 'light' ? 'dark' : 'system';
}
